import * as types from 'store/modal/modalTypes'

const initialModalState = {
  show: false,
  state: {},
}

const initialState = {
  noShowModal: initialModalState,
}

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_NO_SHOW_MODAL:
      return { ...state, noShowModal: { show: true, state: action.payload } }
    case types.MARK_PARTICIPANT_AS_NO_SHOW_SUCCEEDED:
      return { ...state, noShowModal: initialModalState }
    default:
      return state
  }
}

export default modalReducer
